var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dl", { staticClass: "modal__uploaderror" }, [
    _c("dt", { staticClass: "modal__uploaderror_title" }, [
      _vm._v("\n    " + _vm._s(this.message) + "\n  ")
    ]),
    _vm._v(" "),
    _c("dd", { staticClass: "modal__uploaderror_descr" }, [
      _vm.errorType === 0
        ? _c("p", {
            staticClass: "modal__uploaderror_para",
            domProps: {
              innerHTML: _vm._s(
                this.config.lang["ebrief.error.upload_error_type0_praelist0"]
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "modal__uploaderror_filenames" },
        [
          _vm._l(_vm.displayed, function(filename) {
            return _c("li", { staticClass: "modal__uploaderror_item" }, [
              _c("span", { staticClass: "modal__uploaderror_itemfilename" }, [
                _vm._v(_vm._s(filename))
              ])
            ])
          }),
          _vm._v(" "),
          this.count > 3
            ? _c("li", { staticClass: "modal__uploaderror_item" }, [
                _vm._v(
                  "\n        … und " +
                    _vm._s(this.allFilesSize - 3) +
                    " weitere\n      "
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.errorType === 0
        ? _c("p", {
            staticClass: "modal__uploaderror_para",
            domProps: {
              innerHTML: _vm._s(
                this.config.lang["ebrief.error.upload_error_type0_suflist0"]
              )
            }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }